import styled from 'styled-components'

const ListItem = styled.li`
  margin: 0;
  display: flex;
  flex-direction: row;

  svg + div {
    flex: 1;
    padding-left: ${props => props.theme.gutter}px;
  }
`

export default ListItem
